export function injectTenantStyles(tenantId: number) {
  const baseUrl = import.meta.env.VITE_S3_URL || '';
  const link = document.createElement('link');
  link.rel = 'stylesheet';
  link.href = `${baseUrl}${tenantId}/styles/fh_theme.css`;
  document.head.appendChild(link);
}
